module.exports = __webpack_public_path__ + "fonts/Inter-Light.780dd2a.woff2";